import { render } from "./text-property-files-uploader.vue?vue&type=template&id=edc0ac9b"
import script from "./text-property-files-uploader.vue?vue&type=script&lang=js"
export * from "./text-property-files-uploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__